import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import logo from "../assets/images/apemlogo.png"; // Importando a logo corretamente

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email.toLowerCase());
    };

    const handleForgotPassword = async () => {
        if (!email) {
            alert("Por favor, insira seu e-mail.");
            return;
        }

        if (!validateEmail(email)) {
            alert("Por favor, insira um e-mail válido.");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post("https://sis.itraker.com.br/api/forgot-password", {
                email: email.toLowerCase(),
            });

            if (response.status === 200) {
                alert("Se o e-mail estiver cadastrado, você receberá um link para redefinir sua senha.");
                navigate("/");
            }
        } catch (error) {
            alert("Erro ao solicitar recuperação de senha. Tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={styles.container}>
            <img src={logo} alt="Logo" style={styles.logo} />

            <h2 style={styles.title}>Recuperar Senha</h2>

            <p style={styles.description}>Digite seu e-mail para receber um link de redefinição de senha.</p>

            <input
                type="email"
                name="email"
                placeholder="E-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={styles.input}
            />

            <button
                onClick={handleForgotPassword}
                disabled={loading}
                style={styles.button}
            >
                {loading ? "Enviando..." : "Enviar Link"}
            </button>

            <button
                style={styles.registerText}
                onClick={() => navigate("/")}
            >
                Lembrou a senha? <span style={styles.registerLink}>Entrar</span>
            </button>

            {loading && (
                <div style={styles.modalBackground}>
                    <div style={styles.activityIndicatorWrapper}>Carregando...</div>
                </div>
            )}
        </div>
    );
}

const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#F5F5F5",
        height: "100vh",
        padding: 20,
    },
    logo: {
        width: 250,
        height: 120,
        marginBottom: 20,
        objectFit: "contain",
    },
    title: {
        fontSize: "24px",
        fontWeight: "bold",
        marginBottom: "10px",
    },
    description: {
        fontSize: "16px",
        color: "#555",
        textAlign: "center",
        marginBottom: "20px",
        maxWidth: "350px",
    },
    input: {
        width: "80%",
        maxWidth: "400px",
        padding: "12px 15px",
        margin: "10px 0",
        border: "1px solid #cccccc",
        borderRadius: "10px",
        backgroundColor: "#FFFFFF",
        color: "#333",
        fontSize: "16px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    },
    button: {
        width: "80%",
        maxWidth: "400px",
        padding: 15,
        backgroundColor: "#1A237E",
        color: "#FFFFFF",
        border: "none",
        borderRadius: 10,
        cursor: "pointer",
        fontSize: 18,
        fontWeight: "bold",
        marginTop: 10,
    },
    registerText: {
        background: "none",
        border: "none",
        fontSize: 14,
        cursor: "pointer",
        marginTop: 15,
    },
    registerLink: {
        color: "#1A237E",
        fontWeight: "bold",
    },
    modalBackground: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    activityIndicatorWrapper: {
        backgroundColor: "#FFFFFF",
        padding: 20,
        borderRadius: 10,
    },
};
